import script from "./MentorSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MentorSelection.vue?vue&type=script&setup=true&lang=ts"

import "./MentorSelection.vue?vue&type=style&index=0&id=787d013a&lang=css"

const __exports__ = script;

export default __exports__